// src/features/user/userSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { AUTH_SHOP } from '../constants/storeConstants';

const initialState = {
  isFetchTokenLoading: true,
  isFetchTokenSuccess: false,
  isFetchTokenError: false,
  fetchTokenData: null,
  fetchTokenError: null,
  orderReferenceId: null
};

const authShopSlice = createSlice({
  name: AUTH_SHOP,
  initialState,
  reducers: {
    getSyscoShopAuthToken: (state, action) => {
      state.isFetchTokenLoading = true;
      state.isFetchTokenError = false;
      state.isFetchTokenSuccess = false;
      state.fetchTokenError = null;
      state.orderReferenceId = action.payload;
    },
    getSyscoShopAuthTokenSuccess: (state, action) => {
      state.isFetchTokenLoading = false;
      state.isFetchTokenSuccess = true;
      state.isFetchTokenError = false;
      state.fetchTokenData = action.payload;
    },
    getSyscoShopAuthTokenError: (state, action) => {
      state.isFetchTokenLoading = false;
      state.isFetchTokenSuccess = false;
      state.isFetchTokenError = true;
      state.fetchTokenError = action.payload;
    }
  },
});

export const {
  getSyscoShopAuthToken,
  getSyscoShopAuthTokenSuccess,
  getSyscoShopAuthTokenError } = authShopSlice.actions;

export default authShopSlice.reducer;
